import React, { ReactNode } from "react"
import { TbX } from "react-icons/tb"

interface ModalProps {
	isOpen: boolean
	onClose: () => void
	closeOnOverlayClick?: boolean
	showCloseButton?: boolean
	title?: string
	children: ReactNode
	titleClassName?: string
	maxWidth?: string
}

const Modal: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	closeOnOverlayClick = true,
	showCloseButton = true,
	title,
	children,
	titleClassName,
	maxWidth = "max-w-[800px]",
}) => {
	if (!isOpen) return null

	const handleOverlayClick = () => {
		if (closeOnOverlayClick) onClose()
	}

	return (
		<div
			className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
			onClick={handleOverlayClick}
		>
			<div
				className={`bg-white rounded-lg p-8 w-full  mx-4 relative ${maxWidth}`}
				onClick={(e) => e.stopPropagation()}
			>
				{(title || showCloseButton) && (
					<div className="flex justify-between items-center mb-2">
						{title && (
							<h2
								className={`font-semibold  text-[20px] text-[#3D3D3D]  ${titleClassName}`}
							>
								{title}
							</h2>
						)}
						{showCloseButton && (
							<div
								className="p-2 hover:bg-[#F0F0F0] rounded-[8px] cursor-pointer"
								onClick={onClose}
							>
								<TbX size="20px" color="#6D6D6D" />
							</div>
						)}
					</div>
				)}
				<div>{children}</div>
			</div>
		</div>
	)
}

export default Modal
